import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "A roadtrip: First leg",
  "description": "",
  "published": "2012-07-27T00:00:00.000Z",
  "redirect_from": ["/blog/a-roadtrip-first-leg/swizec/4906"],
  "categories": "Croatia, Dalmatia, Dubrovnik, Jesus, Mostar, Plitvice Lakes National Park, Roadtrip, Travel + Events",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-43-1024x764.jpg",
        "alt": "Roadtrip Croatia",
        "title": "Roadtrip Croatia"
      }}></img></p>
    <p>{`Here I am. Here `}<em parentName="p">{`we`}</em>{` are, on a roadtrip of epic proportions ... or rather, as much as you can pack into ten days.`}</p>
    <p>{`This is the main event of the summer, the reason I borrowed `}<a parentName="p" {...{
        "href": "http://twitter.com/smotko"
      }}>{`@smotko`}</a>{`'s car. The plan is to make it down to `}<a parentName="p" {...{
        "href": "http://whc.unesco.org/en/list/95",
        "title": "Old City of Dubrovnik"
      }}>{`Dubrovnik`}</a>{` - some 600km away from home - visit `}<a parentName="p" {...{
        "href": "http://www.bruceleefoundation.com/",
        "title": "Bruce Lee"
      }}>{`Bruce Lee`}</a>{`'s statue in `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=43.3333333333,17.8&spn=0.1,0.1&q=43.3333333333,17.8%20(Mostar)&t=h",
        "title": "Mostar"
      }}>{`Mostar`}</a>{`, then go visit some Croatian islands for a few days of proper lounging around the beach like a pair of cows.`}</p>
    <p>{`Yesterday at ungodly hours in the morning the expedition was launched. So far the journey's included:`}</p>
    <ul>
      <li parentName="ul">{`hoards of cow-eyed tourists with their brain shut off, trying to take the single best picture of `}<a parentName="li" {...{
          "href": "http://whc.unesco.org/en/list/98",
          "title": "Plitvice Lakes National Park"
        }}>{`Plitvice Lakes`}</a>{` ... no idea why they bothered, of course ours are going to be best.`}</li>
      <li parentName="ul">{`discovering `}<a parentName="li" {...{
          "href": "http://maps.google.com/maps?ll=45.8,16.0&spn=10.0,10.0&q=45.8,16.0%20(Croatia)&t=h",
          "title": "Croatia"
        }}>{`Croatia`}</a>{` is actually beautiful - but only inland `}<a parentName="li" {...{
          "href": "http://en.wikipedia.org/wiki/Dalmatia",
          "title": "Dalmatia"
        }}>{`Dalmatia`}</a>{`, the `}<a parentName="li" {...{
          "href": "http://swizec.com/blog/geek-at-a-music-festival-day-1/swizec/4825",
          "title": "Geek at a music festival: Day 1"
        }}>{`flatland on the way to EXIT`}</a>{` was weird and the coast is full of lazy cowstourists`}</li>
      <li parentName="ul">{`a scary old house without working electricity`}</li>
      <li parentName="ul">{`sleeping on the balcony of said house ... and later inside, with all the ghosts keeping us company`}</li>
      <li parentName="ul">{`hydroelectric power plant `}<em parentName="li">{`inside a fucking mountain`}</em></li>
      <li parentName="ul">{`one of the best looking longboarding roads ever ... with `}<em parentName="li">{`maaaaaaybe`}</em>{` just a bit too much traffic ... maybe, we'll see, I might have to sneak out while `}<a parentName="li" {...{
          "href": "http://twitter.com/ponywithhiccups"
        }}>{`@ponywithhiccups`}</a>{` isn't looking`}</li>
      <li parentName="ul">{`huge wind tourbines! very huge!`}</li>
      <li parentName="ul">{`getting to know the interior of Car, very very well`}</li>
    </ul>
    <p>{`Oh and we took some possibly good photos. Take a look, y'know, if you want to. I'm a blogpost not a cop.`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/IMG_20120726_183936.jpeg",
        "alt": "Plitvice Lakes - where boats chase trains",
        "title": "Plitvice Lakes - where boats chase trains"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/IMG_1452-768x1024.jpg",
        "alt": "Forestry!",
        "title": "Forestry!"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/IMG_1438-768x1024.jpg",
        "alt": "Jesus was a chump, this is how you do it",
        "title": "Jesus was a chump, this is how you do it"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-13-e1343393002368.jpeg?1d5d3d",
        "alt": "The greenest green",
        "title": "The greenest green"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-23-1024x764.jpg",
        "alt": "*whisper* I see dead trees",
        "title": "*whisper* I see dead trees"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/IMG_1559-768x1024.jpg",
        "alt": "Waterfalliness",
        "title": "Waterfalliness"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/IMG_1565-1024x768.jpg",
        "alt": "Down, down, down",
        "title": "Down, down, down"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/IMG_1646-1024x768.jpg",
        "alt": "Roadtrip - the picture",
        "title": "Roadtrip - the picture"
      }}></img></p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2012/07/photo-52-1024x764.jpg",
        "alt": "View from the longboard road",
        "title": "View from the longboard road"
      }}></img></p>
    <h6 {...{
      "id": "related-articles"
    }}>{`Related articles`}</h6>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://theegotripper.com/2012/06/17/croatia-blog-week-plitvice/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/94797801_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://theegotripper.com/2012/06/17/croatia-blog-week-plitvice/"
        }}>{`Croatia Blog Week: Plitvice`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://travelnotes.wordpress.com/2012/06/18/focus-on-croatia/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/94912564_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://travelnotes.wordpress.com/2012/06/18/focus-on-croatia/"
        }}>{`Focus on Croatia`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://girlonamissionblog.wordpress.com/2012/06/03/roadtrip/"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/93119465_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://girlonamissionblog.wordpress.com/2012/06/03/roadtrip/"
        }}>{`Roadtrip`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "http://www.confused.com/guides/motoring/car-insurance/confused-com-s-guide-to-driving-in-croatia-2442555746"
        }}><img parentName="a" {...{
            "src": "https://i.zemanta.com/noimg_21_80_80.jpg",
            "alt": null
          }}></img></a><a parentName="li" {...{
          "href": "http://www.confused.com/guides/motoring/car-insurance/confused-com-s-guide-to-driving-in-croatia-2442555746"
        }}>{`Confused.com's Guide to Driving in Croatia`}</a></li>
    </ul>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/?px",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=6cc1b74a-b1ec-40fc-b87b-ab5aaaa08830",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      